/** @type {import('@vue/compat').ComponentOptions} */
import downloadBoxMixin from './download-box-mixin.js';

export default {
    mixins: [downloadBoxMixin],
    data:{
        list:'',
        data:'',
        show:false,
        index:0,
        scroll:''
    },
    mounted(){
        this.getList()
    },
    methods:{
        getList(){

            let data = {
                'post_id':qk_global.post_id,
            }

            this.$http.post(qk_rest_url+'getDownloadData',data).then(res=>{
                this.list = res.data;
                this.data = this.list[0];
                if (window.qkDownloadBox) {
                    window.qkDownloadBox.list = this.list;
                    window.qkDownloadBox.data = this.data;
                }
                
                this.$nextTick(() => {
                    if(this.$refs.scrollTab) {
                        this.scroll = new BScroll(this.$refs.scrollTab, {
                            scrollX: true,
                            probeType: 3, // listening scroll event
                            click:true    
                        })
                    }
                });
            }).catch((err) => {
                qkShowApiError(err, '加载下载信息失败');
            })
        },
    }
};
